var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.list),function(item,index){return [_c('span',{on:{"click":function($event){_vm.handleClick(index)}}},[_c('em',{style:({'background': item})})]),_vm._v(" "),((index + 1) % 12 === 0 && index !== 0 && (index + 1) !== _vm.list.length)?_c('br'):_vm._e()]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9ae3190","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview/src/components/color-picker/recommend-colors.vue
// module id = null
// module chunks = 